module.exports = __webpack_public_path__ + "img/adobe-8.e4fa81bd.png";